import type {
  GlobalAssistantDiscoveryKind,
  GlobalAssistantSuggestMatch,
} from './global-ai-assistant-api';

const DATA_DICTIONARY_PATH = '/data-dictionary';

export type GlobalAssistantPageMatchAction =
  | { kind: 'navigate_only' }
  | { kind: 'resolve_route_filters' }
  | {
      kind: 'apply_discovery_filters_after_navigate';
      discoveryKind: GlobalAssistantDiscoveryKind;
    };

export function getGlobalAssistantPageMatchAction(
  match: GlobalAssistantSuggestMatch,
  prompt?: string
): GlobalAssistantPageMatchAction {
  const hasPrompt = Boolean(prompt?.trim());
  if (match.discoveryKind) {
    if (match.applyFiltersAfterNavigate && hasPrompt) {
      return {
        kind: 'apply_discovery_filters_after_navigate',
        discoveryKind: match.discoveryKind,
      };
    }
    return { kind: 'navigate_only' };
  }
  if (match.navigatePath === DATA_DICTIONARY_PATH) {
    return { kind: 'navigate_only' };
  }
  if (hasPrompt) {
    return { kind: 'resolve_route_filters' };
  }
  return { kind: 'navigate_only' };
}

export function getGlobalAssistantPageMatchesDefaultMessage({
  hasCurrentPageFilterApplyOption,
  matches,
}: {
  hasCurrentPageFilterApplyOption: boolean;
  matches: GlobalAssistantSuggestMatch[];
}): string {
  if (
    matches.length > 0 &&
    matches.every((match) => match.navigatePath === DATA_DICTIONARY_PATH)
  ) {
    return 'Open the Data Dictionary for methodology and metric definitions.';
  }
  if (hasCurrentPageFilterApplyOption) {
    return 'I can apply these filters to the current page:';
  }
  if (matches.length === 1) {
    return 'I can apply these filters to the page below:';
  }
  return 'I can apply these filters to one of the following pages:';
}
